import { Link, useNavigate } from 'react-router-dom';
import './Formfillercomp.css';
import { useEffect, useState } from 'react';
import api from '../jobsite/Components/api.js'; 
let Formfillercomp=(props)=>{
    let navigate = useNavigate();
    let [email, setemail]=useState(null);
    let [password, setpassword]=useState(null);
    useEffect(()=>{
    let login = localStorage.getItem("login");
    if(login){
        navigate("/applicant-form-filling");
    }
    let logstatus= localStorage.getItem("loginstatus");
    if(logstatus){
        setTimeout(function(){
                localStorage.clear();  
                window.location.reload();
            }, 2000); 
    }
      
             
    },[])
    
    let emailinputhandel=(e)=>{ 
        setemail(e.target.value);
    } 
    let passwordinputhandel=(e)=>{ 
        setpassword(e.target.value);
    }
    



    let [userdata, setuserdata]=useState(null);
    let searchbtn=async()=>{ 
       if(email===null){
            document.querySelector(".usrnotfoundd").innerHTML = "Email Required";
            document.querySelector(".usercont").style.display="none";
            props.Successandrerrorfun("" , "Email Required");
            return;
       }else if(password===null){
            document.querySelector(".usrnotfoundd").innerHTML = "password Required"; 
            props.Successandrerrorfun("", "Password Required");
            document.querySelector(".usercont").style.display="none";
            return;
       }
        let searchfromdata= new FormData(); 
        searchfromdata.append('email', email);
        searchfromdata.append('password', password);

       try {
         const resp = await api.post('/searchbykeyword.php', searchfromdata);
          if(resp.data.result !== "Email-Id Invalid Or User not Registered..!!!" && resp.data.result !== "Both Fildes are required" && resp.data.result !== "Password Invalid"){
            document.querySelector(".usercont").style.display="block";
            document.querySelector(".usrnotfoundd").innerHTML = "";
            document.querySelector(".forgotalink").style.display="none";  
            setuserdata(resp.data.data);  
              
          }else{

            document.querySelector(".usrnotfoundd").innerHTML = resp.data.result;
            document.querySelector(".forgotalink").style.display="block";
            document.querySelector(".usercont").style.display="none"; 
            props.Successandrerrorfun("", resp.data.result);
             


          }
          if(resp.data.result === "Search Field empty"){
            document.querySelector(".usrnotfoundd").innerHTML = resp.data.result;
            document.querySelector(".forgotalink").style.display="block";
            props.Successandrerrorfun("", resp.data.result);
            document.querySelector(".usercont").style.display="none";



          }
         
       } catch (error) {
            console.log(error);
       }
    }
    let founduserclickhandel=()=>{  
        localStorage.setItem("login", true); 
        props.getapplicantdata(userdata);
        navigate('/applicant-form-filling');
    }

    return(
        <div className='fillformmaincop'>
            <h3 className='fillformheading'>Applicants Registration and login</h3>
            <div className='subcontfillform'>   
                <div className='regyourdet fillsm'>
                    <p className='noticeforapplicantadddetails'>If User not registered click on add your Details</p>
                    <button className='adddetbtn'>
                        <Link to="../applicants-register-form">Add Your Details</Link>
                    </button>
                </div>
                <div className='searchyourdet fillsm'>
                    <div className='sarbtnandinput'>
                        <input onChange={emailinputhandel} name='email' type='text' placeholder='Email-Id'/>
                        <input onChange={passwordinputhandel} type='password' placeholder='Password'/>
                        <div style={{textAlign:"center", width:"100%", margin:"10px 0"}}>
                        <button className='gobtn' onClick={searchbtn}>search</button>

                        </div>

                    </div>
                    <div className='searchoutput'>
                        <div onClick={founduserclickhandel} style={{display:"none"}} className='usercont'>
                            <div className='usersubcont'>
                                <span className='imgspan'>
                                <img className='aplphoto' src={'https://makeeasyway.in/jobSiteData/'+userdata?.photo} alt='hello'/>
                            </span>
                            <span className='nameandmobnum'>
                                <p>{userdata?.applicantname}</p>
                                <p>{userdata?.mobilenum}</p>

                            </span>
                            </div>
                        </div> 
                        
                        <div  className='usrnotfound'>
                            <a className='forgotalink'  onClick={(e)=>{
                                e.preventDefault();
                                alert("Available soon...!!! until do not forgot password")}}>Forgot password...!!!</a>
                            <p style={{textAlign:"center", fontSize:"20px", color:"red"}} className='usrnotfoundd'></p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default Formfillercomp;